import type { PiletApi, PiletUserContext } from '@sharefiledev/sharefile-appshell';

export const userIsEntitled = (piletApi: PiletApi): boolean => {
	// If this logic is modified, ensure corresponding updates are made in FBP:
	// https://code.sharefile-coretools.com/projects/SF_SYSTEM/repos/sharefile-storage/browse/src/ShareFile.Services.Storage.Core/v3/NavigationResource/NavigationResourceService.cs#94
	const { entitlements }: PiletUserContext = piletApi.sf.piletUserContext.get();
	if (!entitlements.getEntitlementStatus('sharefile:entitlementdef-create-project')) {
		return false;
	}

	return true;
};
